export const Translations_bg = {
    "welcomePageTitle": "Изберете вашите",
    "lockerName": "Easybox име",
    "lockerId": "Easybox Id",
    "address": "Адрес",
    "selectBtn": "Изберете easybox",
    "select": "Изберете...",
    "county": "Държава",
    "city": "Град",
    "easyboxNameStreet": "Easybox / име улица...",
    "backToLockerList": "< Върнете се към списъка",
    "favouriteLocker": "Маркирайте като предпочитан",
    "removeFavouriteLocker": "Прехнете предпочитан",
    "openOnGoogleMaps": "Отворете с Google Maps",
    "monday": "Понеделник",
    "tuesday": "Вторник",
    "wednesday": "Сряда",
    "thursday": "Четвъртък",
    "friday": "Петък",
    "saturday": "Събота",
    "sunday": "Неделя",
    "non-stop": "постоянно",
    "lockerSchedule": "График",
    "seeOnMap": "Вижте на картата",
    "locationDisclaimer": "Моля, уверете се, че вашето местоположение е активирано и разрешете достъп, когато браузърът/устройството ви поиска разрешения за местоположение.",
    "findMeOnMap": "Намерете на картата",
    "searchFilters": "Търсете филтри",
    "locationError1": "Локализиране на местоположение не се подържа от този браузър.",
    "locationError2": "Грешка за местоположение: Отказан достъп!",
    "locationError3": "Грешка за местоположение: Локализацията е недостъпна!",
    "clientNotFoundErrorMsg": "Грешка! Клиентът не е открит!",
    "sdkNotFoundErrorMsg": "Грешка! Easybox Plugin SDK не е октрит!",
    "search": "Потърсете всякакви подробности за easybox",
    "searchBy": "Може да търсите по:",
    "easyboxName": "Easybox име",
    "street": "Улица",
    "showEasyboxList": "Покажи easybox списък",
    "hideEasyboxList": "Скрии easybox списък",
    "searchError1": "Въведеният текст трябва да е между ${minLimit} и ${maxLimit} символа",
    "searchError2": "Въведеният текст не може да съдържа специални символи: ${notAllowedSpecial}",
    "home": "Жилище",
    "work": "Работа",
    "onlyPOSLockers": "Само easyboxes с POS плащане",
    "advancedFilters": "Филтри",
    "posAtLocation": "Налично POS плащане на място:",
    "yes": "Да",
    "no": "Не",
    "showAllTheLockersInArea": "Покажи всички easyboxes в тази зона",
    "showSelectedLocker": "Покажи избраните easybox",
    "hideSelectedLocker": "Скрий избраните easybox",
    "noEasyboxesFound": "Няма намерени easyboxes, моля опитайте друго търсене."
}